// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","22573": "54bce21baa54","4380": "c44485e5b00c","49457": "02846d78c2ad","53263": "b59a823fcae8","66863": "c939bdd77392","70148": "51afc41e5aee","81474": "f5cead850995","96417": "b62ccc841ab2","98272": "20efdd17d94f",}[chunkId] + ".css"
}